export enum ScoringForType {
  ITRA = 1,
  CONFIGURE = 2,
}
